export const SERVICES_URLS = {
  MAIN_APP: process.env.NEXT_PUBLIC_SAJILNI_MAIN_APP,
  ORDER_APP: process.env.NEXT_PUBLIC_SAJILNI_ORDER_APP,
  FORM_BUILDER_APP: process.env.NEXT_PUBLIC_FORM_BUILDER_APP,
  NOTIFICATION_APP: process.env.NEXT_PUBLIC_NOTIFICATION_APP,
  PAYMENT_APP: process.env.NEXT_PUBLIC_PAYMENT_APP,
  MALGA_VIRTUAL: process.env.NEXT_PUBLIC_MALGA_VIRTUAL_APP,
  CONTENT_MANGER_APP: process.env.NEXT_PUBLIC_CONTENT_MANGER_APP,
  INTEGRATION_APP: process.env.NEXT_PUBLIC_INTEGRATION_APP,
  AE_SAJILNI: process.env.AE_SAJILNI,
  TASHBEEK_APP: process.env.NEXT_PUBLIC_TASHBEEK_APP,
  LEGACY_APP: process.env.NEXT_PUBLIC_LEGACY_APP,
  HYPERPAY_URL: process.env.NEXT_PUBLIC_HYPERPAY_URL,
  DTCM_APP: process.env.NEXT_PUBLIC_DTCM_APP,
} as const;

export enum CHECK_IN_OUT {
  CHECK_OUT = "CHECK_OUT",
  CHECK_IN = "CHECK_IN",
}

export * from "./Invitation";
export * from "./Transition";
export * from "./Ticket";
export * from "./Login";
export * from "./Event";
export * from "./Payments";
export * from "./User";
export * from "./idempotency";
export * from "./reports";
export * from "./checkin";
